// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9goQj","productName":"Table_productName__2FR0A"};